import { render, staticRenderFns } from "./DeploymentsSection.vue?vue&type=template&id=f4485f0c&"
import script from "./DeploymentsSection.vue?vue&type=script&lang=js&"
export * from "./DeploymentsSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports